import script from "./ProductDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetailModal.vue?vue&type=style&index=0&id=70584dbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70584dbe"]])

export default __exports__